// extracted by mini-css-extract-plugin
export default {"root":"CustomNode_root__p+FnW","expandIconWrapper":"CustomNode_expandIconWrapper__XoqZW","isOpen":"CustomNode_isOpen__bnTNp","labelGridItem":"CustomNode_labelGridItem__fBHts"};